import { render } from "./UnsplashSlider.vue?vue&type=template&id=56b76bcc"
import script from "./UnsplashSlider.vue?vue&type=script&lang=js"
export * from "./UnsplashSlider.vue?vue&type=script&lang=js"

import "./UnsplashSlider.vue?vue&type=style&index=0&id=56b76bcc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__